import {useStore} from "../helpers/helpers";
import {safe_get} from "../report-visuals/report-utils";


export const useRole = () => {
    const rootStore = useStore();
    const userProfile = rootStore.userStore?.user;
    return safe_get(userProfile, "role", "")
}